import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export default function Education() {
  return (
    <div className="section">
      <h1 className="fw-bold mb-3">Education</h1>
      <p className="fs-5 mb-2">
        The best consulting engagement is one that makes you less dependent on the consultant.
        M3 Computing has spent over a decade designing and delivering technical education for
        engineering teams ranging from small startups to large enterprises — and education is
        built into how we approach every engagement, not offered as an add-on.
      </p>
      <p className="fs-5 mb-5">
        We also offer education as a standalone service in three formats: live training
        workshops, custom video course production, and ongoing technical advisory.
      </p>

      <hr className="m3-divider mb-5" />

      <Row className="g-5">
        <Col md={12}>
          <h2 className="fw-bold mb-3">Live Training</h2>
          <Row>
            <Col md={6}>
              <p>
                Custom technical training workshops designed around your team's stack,
                experience level, and learning goals. We don't deliver generic content pulled
                from a catalog — every program is built specifically for the engineers in
                the room.
              </p>
              <p>
                We design hands-on labs, real-world exercises, and assessments that reinforce
                concepts through practice. Teams leave with skills they can apply immediately,
                not just slides to reference later.
              </p>
            </Col>
            <Col md={6}>
              <h3 className="h6 fw-bold mb-2">Topics we cover</h3>
              <ul className="mb-3">
                <li>Cloud-native architecture and development</li>
                <li>Kubernetes and container platform engineering</li>
                <li>Microservices design patterns</li>
                <li>Java and Spring Framework</li>
                <li>Go</li>
                <li>Application security</li>
                <li>CI/CD and DevOps practices</li>
              </ul>
              <h3 className="h6 fw-bold mb-2">Formats</h3>
              <ul className="mb-0">
                <li>Half-day to multi-day workshops</li>
                <li>Remote or on-site</li>
                <li>Hands-on labs and structured exercises</li>
                <li>Custom content built around your technology</li>
              </ul>
            </Col>
          </Row>
        </Col>

        <Col md={12}>
          <hr className="m3-divider mb-5" />
          <h2 className="fw-bold mb-3">Custom Video Courses</h2>
          <Row>
            <Col md={6}>
              <p>
                Need training content your team can access on their own schedule? We script,
                produce, and deliver custom video courses built around your technology, your
                architectural patterns, and your engineering standards.
              </p>
              <p>
                The finished courses are yours. We hand over the video content for you to
                host and distribute internally — through your LMS, your intranet, or however
                your team accesses training. There are no ongoing licensing fees or
                platform dependencies.
              </p>
            </Col>
            <Col md={6}>
              <h3 className="h6 fw-bold mb-2">Where custom video works well</h3>
              <ul className="mb-0">
                <li>Onboarding new engineers to your stack and standards</li>
                <li>Documenting architectural decisions and the reasoning behind them</li>
                <li>Building consistent technical foundations across distributed teams</li>
                <li>Preserving institutional knowledge that lives only in people's heads</li>
                <li>Supplementing live training with on-demand reference content</li>
              </ul>
            </Col>
          </Row>
        </Col>

        <Col md={12}>
          <hr className="m3-divider mb-5" />
          <h2 className="fw-bold mb-3">Technical Advisory</h2>
          <Row>
            <Col md={6}>
              <p>
                Ongoing technical mentoring and coaching for engineering teams and individual
                contributors. We work with your engineers over time — reviewing architecture
                decisions, advising on technology choices, and helping your team grow into
                the problems they're solving.
              </p>
              <p>
                This isn't staff augmentation. It's a structured advisory relationship focused
                on building engineering capability and judgment, not just solving individual
                problems.
              </p>
            </Col>
            <Col md={6}>
              <h3 className="h6 fw-bold mb-2">Engagement models</h3>
              <ul className="mb-0">
                <li>Regular advisory sessions with engineering leads or individual contributors</li>
                <li>Architecture reviews and design feedback</li>
                <li>Technology evaluation and selection guidance</li>
                <li>Code and design review with detailed written feedback</li>
                <li>On-demand support for time-sensitive decisions</li>
              </ul>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}
